import * as React from 'react'
import {  useSelector } from 'react-redux'
import {  RootReducer } from "../../../components/app/reducer"
import { Link } from "react-router-dom"
import { RouteComponentProps } from "react-router" 
import { Depository } from '../../../openapi/depository'

type RouteParams = {
    depcode: string
  }

type Props = RouteComponentProps<RouteParams> 

const DepoDetail: React.FC<Props> = ( props ) => {
    const depCode = props.match.params.depcode; 
    // all the data should be available in ccb search
    const depos = useSelector( (state:RootReducer) =>  state.depositoryReducer.depositories) || []
    const depoToDisplay = depos.find((depo:Depository) => depo.code === depCode ) || {}

    return (
        <div id="depo-detail">
            <p><Link to="/deporesults">Back to List</Link></p>
            <p className="codelist-header"><span className="bold">Depository Details</span></p>
            <div id="content">
                <div className="detail-pane">
                    <div className="detail-table">
                        {
                            [["Depository Code :", depoToDisplay.code], 
                            ["Depository Name :", depoToDisplay.name],
                            ["Depository Address :", depoToDisplay.address],
                            ["Depository City :", depoToDisplay.city],
                            ["Depository Country :", depoToDisplay.ctry],
                            ["Abbreviation :", depoToDisplay.abbrev],
                            ["Depository Type :", depoToDisplay.type + "*"]
                            ].map( (rowData) => 
                                <div className="detail-table-row" key={rowData.join("|")}>
                                    <span className="detail-table-col-left" key={rowData[0]}>{rowData[0]}</span>
                                    <span className="detail-table-col-right" key={rowData[1]}>{rowData[1]}</span>
                                </div>)
                        }
                    </div>
                </div>
                <div className="note small">
                    { depoToDisplay.type === "CSK" && (<span>(*) The entity appointed by the ICSDs to provide safekeeping for securities in NGN form.</span>) }
                    { depoToDisplay.type === "CSP" && (<span>(*) The entity appointed by the ICSDs to provide asset servicing for securities in NGN form.</span>) }
                    { depoToDisplay.type === "CTA" && (<span>(*) CFF Transfer Agent.</span>) }
                    { depoToDisplay.type === "DOMESTIC" && (<span>(*) Domestic Depositories are specialised depositories holding domestic securities, which may be in various forms.</span>) }
                    { depoToDisplay.type === "EURO" && (<span>(*) Euro Depositories are international specialised depositories. They hold international securities in either physical or book entry form.</span>)}
                    { depoToDisplay.type === "COMMON" && ( <span>(*) Common Depositories are international depositories jointly appointed by Clearstream and Euroclear. They hold international securities in global form.</span>  ) }
				</div>
            </div>
        </div>
    )
} 

export default DepoDetail